import * as React from 'react';
import DatePicker from 'react-datepicker';
import classNames from 'classnames';
import 'react-datepicker/dist/react-datepicker.css';
import './DateTimePickerField.scss';

export interface Props {
  value: Date | null;
  onChange: (dt: Date | null) => void;

  minDate?: Date;
  maxDate?: Date;

  minTime?: Date;
  maxTime?: Date;

  isClearable?: boolean;
  placeholderText?: string;

  isInvalid?: boolean;
  disabled?: boolean;
  wrapperClassName?: string;
  inputClassName?: string;

  popperClassName?: string;
  calendarClassName?: string;
  popperPlacement?: any;

  timeIntervals?: number;
  dateFormat?: string;
  timeFormat?: string;

  showTimeSelect?: boolean;
  customInput?: React.ReactNode;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  tabIndex?: number;
  pickerRef?: React.RefObject<DatePicker>;
  onChangeRaw?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const DateTimePickerField: React.FC<Props> = props => {
  const {
    value,
    onChange,

    minDate,
    maxDate,
    minTime,
    maxTime,

    isClearable = false,
    placeholderText,
    isInvalid = false,
    disabled = false,

    wrapperClassName,
    inputClassName,

    popperClassName = 'eDatePickerPopper',
    calendarClassName = 'eDatePickerCalendar',
    popperPlacement = 'top-start',

    timeIntervals = 15,
    dateFormat,
    timeFormat = 'HH:mm',

    showTimeSelect = true,
    customInput,
    onKeyDown,
    tabIndex,
    pickerRef,
    onChangeRaw
  } = props;

  const resolvedDateFormat = dateFormat || (showTimeSelect ? 'dd MMM yyyy HH:mm' : 'dd MMM yyyy');
  const resolvedPlaceholder = placeholderText || (showTimeSelect ? 'DD Mmm YYYY HH:mm' : 'DD Mmm YYYY');

  const wrapCls = classNames('eDatePickerWrapper', 'eDatePickerWrapperWithIcon', wrapperClassName);
  const inputCls = classNames('form-control', 'eDatePickerInput', inputClassName, { 'is-invalid': isInvalid });

  const resolvedCalendarClassName = classNames(calendarClassName, { eDatePickerCalendarNoTime: !showTimeSelect });

  return (
    <div className={wrapCls}>
      <DatePicker
        ref={pickerRef}
        selected={value}
        onChange={(dt: Date | null) => onChange(dt)}
        className={inputCls}
        placeholderText={resolvedPlaceholder}
        timeInputLabel="Time: "
        showTimeSelect={showTimeSelect}
        dateFormat={resolvedDateFormat}
        timeFormat={timeFormat}
        timeIntervals={timeIntervals}
        timeCaption="Time"
        minDate={minDate}
        maxDate={maxDate}
        minTime={minTime}
        maxTime={maxTime}
        popperClassName={popperClassName}
        calendarClassName={resolvedCalendarClassName}
        popperPlacement={popperPlacement}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        locale="en-GB"
        isClearable={isClearable}
        disabled={disabled}
        customInput={customInput}
        onKeyDown={onKeyDown}
        tabIndex={tabIndex}
        onChangeRaw={onChangeRaw}
      />
    </div>
  );
};

